export default __webpack_public_path__ + "static/media/AIdemos.f330d297.jpg";